import { AxiosResponse } from 'axios';
import VersionedResource from '../VersionedResource';
import { AccountTypeMappingRule } from './AccountTypeMappingRule';

export default class AccountTypeMappingRuleResource extends VersionedResource {
  public async getAll(fiId: string): Promise<AccountTypeMappingRule[]> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/config/${fiId}/account-type-mapping-rule`);
    const rules: AccountTypeMappingRule[] = response.data.data;
    return rules;
  }

  public async save(fiId: string, rule: AccountTypeMappingRule): Promise<AccountTypeMappingRule> {
    const url = `/api/rcx/config/${fiId}/account-type-mapping-rule`;
    let response: AxiosResponse;

    const toSave: any = {};
    Object.assign(toSave, rule);

    if (rule.id) {
      response = await this.apiClient.put(`${url}/${rule.id}`, toSave);
    } else {
      response = await this.apiClient.post(url, toSave);
    }

    const savedRule: AccountTypeMappingRule = response.data.data;
    return savedRule;
  }

  public async remove(fiId: string, ruleId: number): Promise<AxiosResponse> {
    return this.apiClient.delete(`/api/rcx/config/${fiId}/account-type-mapping-rule/${ruleId}`);
  }
}
